import { useApiUtils } from '@core/util/apiUtils';
import { Tooltip } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';
import { EmpresaModais } from 'app/main/empresa/modal';
import empresaApi from 'app/services/api/empresaApi';
import { GlobalContext } from 'app/store/globalcontext';
import { getEmpresaContexto } from 'app/utils/geralUtil';
import React, { useContext, useEffect } from 'react';

function EmpresaSelected() {
  const [nomeEmpresa, setNomeEmpresa] = useContext(GlobalContext).nomeEmpresa;
  const [, setModal] = useContext(GlobalContext).modal;

  const empresaSelectedClick = () => {
    setModal(EmpresaModais.modalSelecionarEmpresa);
  };

  useEffect(() => {
    async function buscarEmpresa() {
      try {
        const respEmpresa = await empresaApi.buscarNome(getEmpresaContexto());

        setNomeEmpresa(respEmpresa.data);
      } catch (err) {
        useApiUtils.handleApiError(err);
      }
    }
    buscarEmpresa();
  }, [setNomeEmpresa]);

  return (
    <>
      <Button className="h-64" onClick={empresaSelectedClick}>
        <div
          className="flex-col mx-12 items-start"
          style={{
            maxWidth: '200px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        >
          <Tooltip title={nomeEmpresa}>
            <Typography component="span" className="normal-case font-600">
              {nomeEmpresa}
            </Typography>
          </Tooltip>
        </div>

        <Icon className="text-16 hidden sm:flex" variant="action">
          keyboard_arrow_down
        </Icon>
      </Button>
    </>
  );
}

export default EmpresaSelected;
